import { serviceApi, tokenRepository, withServiceRequestDefaults } from 'Shared/network';
import { useQueryClient } from '@tanstack/react-query';
import type { CancelWithdrawalByUserUuidOkDto } from 'viewup-api';
import type { ErrorResponse, MutationParam } from 'viewup-lib/common';
import { useSDMutation } from 'viewup-lib/react';

export const useDeleteWithdrawal = (
  params?: MutationParam<CancelWithdrawalByUserUuidOkDto, ErrorResponse, unknown>,
) => {
  const queryClient = useQueryClient();
  const mutationResult = useSDMutation<CancelWithdrawalByUserUuidOkDto, ErrorResponse, unknown>({
    ...params?.options,
    mutationFn: async () => {
      const { data } = await serviceApi.auth.postUserCancelWithdraw(withServiceRequestDefaults());
      return data;
    },
    onSuccess: (response, vars, ctx) => {
      tokenRepository.saveToken(response.data.accessToken);
      queryClient.clear();
      params?.options?.onSuccess?.(response, vars, ctx);
    },
  });

  return mutationResult;
};
